export default {
  title: 'Brands',
  form: {
    name: {
      placeholder: 'Søg efter brand...',
    },
  },
  fields: {
    id: '#',
    name: 'Navn',
    address: 'Adresse',
    subdomain: 'Underdomæne',
    shop_url: 'Butiks-URL',
    companies: 'Virksomheder',
    slug: 'Slug',
    actions: '',
  },
  empty_list: 'Ingen brands endnu',
  modals: {
    delete_franchise: {
      title: 'Er du sikker på, at du vil slette brandet {{name}}?',
    },
  },
  buttons: {
    new_franchise: '+ Tilføj brand',
    export_restaurants: 'Eksportér restauranter',
    edit: 'Rediger',
    delete: 'Slet',
    view_dashboard_as_owner: 'Se dashboard som ejer',
    open_shop: 'Åbn shop',
  },
  toasts: {
    failed_to_load_data: 'Data kunne ikke indlæses',
    failed_to_delete_franchise: 'Brandet kunne ikke slettes',
    franchise_got_deleted: 'Brandet blev slettet',
    failed_to_create_magic_link: 'Magic link kunne ikke oprettes',
    no_owner_to_log_in_as: 'Ingen restaurantejer at logge ind som',
  },
};
